<div class="d-flex align-items-center {{classes}}">
  @if (loading) {
    <div class="tw-size-17 tw-text-3xl tw-mr-3 tw-place-self-center">
      <sb-icon [icon]="'loadingCircleAnimation'" [animationOptions]="{autoplay: true, loop:true}"></sb-icon>
    </div>
  } @else {
    <sb-preview-tooltip
      *ngIf="shouldShowInput('medium')"
      [background]="background"
      [customHeight]="customHeight"
      [customWidth]="customWidth"
      [hoverPreview]="hoverPreview"
      [interval]="tooltipInterval"
      [previews]="previews"
      [showFullOnClick]="showFullOnClick"
      [still]="still"
      [thumbnailSize]="thumbnailSize"
      [hideArrows]="hideArrows"
      [hideIndicators]="hideIndicators"
      class="mr-3">
    </sb-preview-tooltip>
    <div *ngIf="shouldShowInput('image')" [ngStyle]="{'height': customHeight, 'width': customWidth}"
         [style.backgroundImage]=" image ? 'url(' + image + ')' : 'url(./../assets/img/no-image.png)' "
         class="symbol-label mr-3">
    </div>
  }
  <sb-comp-name-wrapper>
    <div *ngIf="firstLine" [classes]="classes" firstLine>
      <ng-content select="[firstLine]"></ng-content>
    </div>
    <div *ngIf="secondLine" [classes]="classes" secondLine>
      <ng-content select="[secondLine]"></ng-content>
    </div>
    <div *ngIf="thirdLine" [classes]="classes" thirdLine>
      <ng-content select="[thirdLine]"></ng-content>
    </div>
    <div *ngIf="fourthLine" [classes]="classes" fourthLine>
      <ng-content select="[fourthLine]"></ng-content>
    </div>
    <div *ngIf="fifthLine" [classes]="classes" fifthLine>
      <ng-content select="[fifthLine]"></ng-content>
    </div>
  </sb-comp-name-wrapper>
</div>
